import { PATIENT } from "../constants";
import { instance } from "../../axios";

let getPatientsByCenter = (centerId) => {
  return async (dispatch) => {
    dispatch({
      type: PATIENT.PATIENT_GET_ALL,
    });
    try {
      const results = await instance.get(`/patient/center/${centerId}`);
      dispatch({
        type: PATIENT.PATIENT_GET_ALL_SUCCESS,
        payload: results.data,
      });
      return results.data;
    } catch (error) {
      dispatch({
        type: PATIENT.PATIENT_GET_ALL_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

let createPatient = (body) => {
  return async (dispatch) => {
    dispatch({
      type: PATIENT.PATIENT_CREATE,
    });
    try {
      const results = await instance.post("/patient", body);
      dispatch({
        type: PATIENT.PATIENT_CREATE_SUCCESS,
        payload: results.data,
      });
      return results.data;
    } catch (error) {
      dispatch({
        type: PATIENT.PATIENT_CREATE_FAILURE,
        payload: error,
      });
      throw error;
    }
  };
};

export { getPatientsByCenter, createPatient };
